"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const enhancers_1 = require("./enhancers");
const expand_aliases_1 = __importDefault(require("./expand-aliases"));
const cache = __importStar(require("./cache"));
const styles = __importStar(require("./styles"));
function enhanceProps(rawProps) {
    const propsMap = expand_aliases_1.default(rawProps);
    const preservedProps = {};
    let className = rawProps.className || '';
    for (const [propName, propValue] of propsMap) {
        const cachedClassName = cache.get(propName, propValue);
        if (cachedClassName) {
            className = `${className} ${cachedClassName}`;
            continue;
        }
        const enhancer = enhancers_1.propEnhancers[propName];
        if (enhancer &&
            (propValue === null || propValue === undefined || propValue === false)) {
            continue;
        }
        else if (!enhancer) {
            preservedProps[propName] = propValue;
            continue;
        }
        const newCss = enhancer(propValue);
        if (newCss) {
            styles.add(newCss.styles);
            cache.set(propName, propValue, newCss.className);
            className = `${className} ${newCss.className}`;
        }
    }
    className = className.trim();
    return { className, enhancedProps: preservedProps };
}
exports.default = enhanceProps;
//# sourceMappingURL=enhance-props.js.map